import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';


export default function useGetBudget(billingCode) {

    const { data, error, mutate } = useSWR(`${apiBaseURL}/api/budget?billingCode=${billingCode}`, {
        //onSuccess: (data) => console.log('Budget fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    const operationBudget = data?.data?.operationsBudget.map(
        (operation) => ({
            id: operation.taskId,
            projectedHours: operation.projectedHours
        })
    );
    const researchBudget = data?.data?.researchBudget.map(
        (research) => ({
            id: research.taskId,
            projectedHours: research.projectedHours
        })
    )
    const materialBudget = data?.data?.materialsBudget.map(
        (material) => ({
            name: material.materialName,
            cost: material.cost,
        })
    );

    const allTotalBudgets = {
        operationsBudgetTotalHours: data?.data?.operationsBudgetTotalHours,
        operationsBudgetTotalCost: data?.data?.operationsBudgetTotalCost,
        researchBudgetTotalHours: data?.data?.researchBudgetTotalHours,
        researchBudgetTotalCost: data?.data?.researchBudgetTotalCost,
        materialsBudgetTotal: data?.data?.materialsBudgetTotal,
    }
    const isLoading = (data?.data === undefined);
    console.log('useGetBudget action', data?.data)
    return {
        operationBudget,
        researchBudget,
        materialBudget,
        allTotalBudgets,
        error,
        isLoading,
        mutate,
    }
}